import AppianTransactionDocuments from "./appian-transaction-documents";

export default AppianTransactionDocuments;
